export const MS_PATH_PREFIX = '/mail-service';
export const MS_API_PREFIX = process.env.REACT_APP_MAIL_SERVICE_API_URL;
